import script from "./DocInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DocInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./DocInfoModal.vue?vue&type=style&index=0&id=ddd76690&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddd76690"]])

export default __exports__